import React from 'react';

export default function Footer() {
  return (
    <footer style={styles.footerContainer} className="py-3">
      <div 
        className="container d-flex flex-column flex-sm-row justify-content-between align-items-center text-white text-center text-sm-start gap-2" 
        style={{ fontSize: '11px' }}
      >
        <div>© 2026 Parag Patil. All Rights Reserved.</div>
        <div>MADE WITH ❤️ COMTRANCE TECHNOLOGY PVT. LTD.</div>
      </div>
    </footer>
  );
}

const styles = {
  footerContainer: {
    backgroundColor: '#0b192c',
  },
};
